/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const placeableRegionDataSchema = z.object({
	placeableFrom: z.string(),
	placeableTo: z.string(),
})

export type PlaceableRegionDataSchema = z.infer<typeof placeableRegionDataSchema>
